import React from 'react';
import PropTypes from 'prop-types';

import styles from './FormFields.module.css';

export const TextInputPreviewHorizontal = ({ label, marginBottom = true, name, showLabel = true, value = ''}) => {
  
  return (
    <div className='d-flex'>
      {(showLabel) && 
      <label htmlFor={ name } className={"me-2 mt-1 " + styles.customPreviewLabel}>{ label }</label>
      }
      <div className={(marginBottom) ? styles.customPreview : styles.customPreviewNoMargin}>{ value }</div>
    </div>
  )
}

TextInputPreviewHorizontal.propTypes = {
  label: PropTypes.string,
  marginBottom: PropTypes.bool,
  name: PropTypes.string.isRequired,
  showLabel: PropTypes.bool,
  value: PropTypes.string,
}